export default {
  index: [
    {
      path: '/zkpartnerinfo',
      component: resolve => require(['./zkpartnerinfoIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/zkpartner_info/_router.js